import { IGoogleMapsConfiguration } from './configure';
import { GoogleMaps } from './google-maps';
export { GoogleMaps } from './google-maps';
export { IGoogleMapsConfiguration } from './configure';
export { IMarkerClustering } from './marker-clustering';
const DefaultComponents = [
    GoogleMaps,
];
function createGoogleMapsConfiguration(options) {
    return {
        register(container) {
            const configClass = container.get(IGoogleMapsConfiguration);
            configClass.options(options);
            return container.register(...DefaultComponents);
        },
        configure(options) {
            return createGoogleMapsConfiguration(options);
        }
    };
}
export const GoogleMapsConfiguration = createGoogleMapsConfiguration({});
// export const GoogleMapsConfiguration = {
//     register(container: IContainer): IContainer {
//         return configure(container);
//     },
//     customize(config?): IRegistry {
//         return {
//             register(container: IContainer): IContainer {
//                 return configure(container, config);
//             }
//         }
//     }
// };
//# sourceMappingURL=index.js.map